export function executeClassicScript(source: string, id: string): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      if (document.getElementById(id)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.id = id;
      script.type = 'text/javascript';
      script.async = false;
      script.setAttribute('data-owner', 'vite-typescript');
      script.text = `${source}\n//# sourceURL=${id}.js`;
      script.onerror = () => reject(new Error(`Classic script kon niet worden uitgevoerd: ${id}`));
      const parent = document.body || document.documentElement;
      parent.appendChild(script);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
}
